cartHandler = {
    $pageCart    : $('.page-cart'),


    init: function(){
        var self = this;

        if (self.$pageCart.length > 0) {
            if (this.$pageCart.find('.cart-empty').length > 0) {
                //self.$pageCart.addClass('cart-empty');
                self.$pageCart.find('h3.title-text').html('Your cart is currently empty.');
            }

            if (self.$pageCart.find('.woocommerce-error').length > 0) {
                var elErr = self.$pageCart.find('.woocommerce-error').html();
                if (elErr.includes('Coupon')) {
                    var $errClone = self.$pageCart.find('.woocommerce-error').clone();
                    self.$pageCart.find('.coupon-and-shipping .coupon').addClass('err-state');
                    $errClone.appendTo(self.$pageCart.find('.coupon-and-shipping .coupon'));

                    setTimeout(() => {
                        var coupOffset = self.$pageCart.find('.coupon-and-shipping').offset().top - 50;
                        if (!$('header').hasClass('headroom--unpinned') && $(window).scrollTop() > 0) coupOffset = coupOffset - $('header').outerHeight(true);
                        mainHandler.scrollto(coupOffset, 300);
                    }, 200);

                    self.$pageCart.find('.coupon-and-shipping #coupon_code').on('input', function() {
                        if ($(this).parents('.coupon').hasClass('err-state')) $(this).parents('.coupon').removeClass('err-state');
                    });
                } else self.$pageCart.find('.woocommerce-notices-wrapper').addClass('error-valid');
            }
        }
    }
}